<template>
  <div id="app">
            <div class="container-fluid" style="background:#fff;margin-bottom:20px;" id="navba">
    <div class="container" style="padding-left:0px;max-width:1180px;">
    <nav  style="padding-left:0px;">
      <div class="navAjs"  >
          <div style="display: flex; align-items: center;">
            <a  href="https://www.lefisc.com.br"> <img src="https://www.lefisc.com.br/imagens/logoOriginal.jpg" style="width:115px;height:27px;margin-left:10px;"></a>
            <p @click="pag" style="cursor:pointer;">ARQLEF</p>
          </div>     
          <router-link v-show="nome != 'empresas' && nome != '' && nome!= 'principal'" style="color: #707070; font-weight:600;"  :to="{ name: 'empresas'}"> Minhas Empresas</router-link>  
      </div>
    </nav>
    </div>
    </div> 
    <br>
    <router-view  />
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return{
      nome:''
    }
  },
  methods:{
    pag(){
      
           this.$router.push({
            name:'principal'
            })
       
    }
  },
  created(){    
    

    let obj = JSON.parse(localStorage.getItem('objCli'))
    
    if(obj != null){
        this.$store.state.idCliente = obj.idCliente
    }else{
       //this.$store.state.idCliente = '9502'
     //window.location = 'https://www.lefisc.com.br/'
      
    }   
    
    if(this.$store.state.idEmpresa == null){
      let o  =  JSON.parse(sessionStorage.getItem("objCli"))
      this.$store.state.idEmpresa = o.idEmpresa
      this.$store.state.razaoSocial = o.razaoSocial     
      this.$store.state.chave = o.chave  
    
 }
  },
   watch: {
    $route(rota){    
     this.nome  = rota.name
    }
  }
 
}
</script>

<style>
.spinerMedio{    
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 10px solid  lightgray;
    border-top-color: #007c74;
    animation: spinnerMedio 0.7s linear infinite;
    margin-top: 10px;
}
@keyframes spinnerMedio{
    to{
        transform: rotate(360deg);
    }
}
.navAjs{
  display:flex;height:60px;align-items: center;justify-content: space-between;
}
#app {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 text-align: center;
 min-height: 84vh;
}
.navAjs p{
  position: relative;
  margin-left:24px;
  display: flex;
  justify-content: space-between;
  color: #383838;
  font-size: 20px !important;
font-weight: 600 !important;
margin-top: 15px;

}
.navAjs p::before{
  content: "";
  position: absolute;
  height: 25px;
  width: 1px;
  top:3px;
  left: -14px;
  background: grey;
}
li{
  position: relative;
}
li.active a{
  color: #383838;
}
li.active a::after{
  content: '';
  position: absolute;
  left:-3px;
  top:13px;  
  width: 1px;
  height: 25px;
  background: #000;
  border-left: .7px solid grey;
}
.containerNcm {
  margin: 0 auto;
  max-width: 1300px;
  background: #fff;
  min-height:80vh;
  
}
.painel2 {
  background-image: url("/sandboxfront/arqlef/img/2645928.jpg");
  background-color: #005e00;
  background-blend-mode: multiply;
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-position: -209px -569px;
}
.painel2 img {
  width: 115px;
}
</style>
